import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isNullOrUndefined } from '@beef/utils';
import { getHousesForStreet, getStreetsForCity } from '@fttb/common/store';
import { vkPushEvent } from '@fttb/common/utils';
import { createAction } from '@reduxjs/toolkit';
import { captureException } from '@fttb/common/components';
import { fetchTariffsByColor } from "../../services/fetchTariffsByColor";
import { sendCheckAddressResultTextAnalytics, sendLeavePhoneClickAnalytics, sendVkCheckAddressEventAnalytics } from "../../blocks/analytics";
import { VkGoalEvent } from "../../blocks/constants";
import { getAnalyticEventType, isPageTypeFmc } from "../blocks/selectors";
import { getCheckAddressCityId, getCheckAddressFormData, getCheckAddressRequestData, getCheckAddressYandexGeocoderData, getFullAddressData, getTextStatusForMobileCheckAddress } from "./selectors";
import { checkHouseConnection } from "../../services/checkHouseConnection";
import { resetColoredTariffsData, setColoredTariffsData, setTariffsGroup } from "../blocks/tariffs/actions";
import { FTTB_PAGE_PREFIX } from "../constants";
import { CHECK_ADDRESS_ACTIONS, GEOCODE_FIRST_RESULT, NOT_FOUND_HOUSE } from "./constants";
import { mapCheckConnectionResponse, mapHouseSuggestionsResponse, mapStreetSuggestionsResponse } from "./mappers";
import { executeYMapsApi, isOldCoordinates, markerFromGeocodeResponse, pointFromGeocodeResponse, validateSelectedTab } from "./utils";
export var setCheckAddressData = createAction("".concat(FTTB_PAGE_PREFIX, "::").concat(CHECK_ADDRESS_ACTIONS, "::setFormValues"));
export var setCheckAddressDetails = createAction("".concat(FTTB_PAGE_PREFIX, "::").concat(CHECK_ADDRESS_ACTIONS, "::setCheckDetails"));
export var setIsLoading = createAction("".concat(FTTB_PAGE_PREFIX, "::").concat(CHECK_ADDRESS_ACTIONS, "::isLoading"));
export var setRenderTooltip = createAction("".concat(FTTB_PAGE_PREFIX, "::setRenderTooltip"));
export var setFlatForForm = createAction('setFlatForForm');
export var setPositionNavButtons = createAction('setPositionNavButtons');
export var setMarkerAddressData = createAction("".concat(FTTB_PAGE_PREFIX, "::").concat(CHECK_ADDRESS_ACTIONS, "::setMarkerAddressData"));
export var resetStore = createAction("".concat(FTTB_PAGE_PREFIX, "::").concat(CHECK_ADDRESS_ACTIONS, "::resetStore"));
export var setCheckAddressFormValues = function setCheckAddressFormValues(values, fromOnchange, isMobile) {
  return function (dispatch, getState) {
    var _values4;
    var state = getState();
    var prevValues = getCheckAddressFormData(state);
    var hasChanged = function hasChanged(fieldName) {
      var _values, _values2;
      return !isNullOrUndefined((_values = values) === null || _values === void 0 ? void 0 : _values[fieldName]) && prevValues[fieldName] !== ((_values2 = values) === null || _values2 === void 0 ? void 0 : _values2[fieldName]);
    };
    var isInvalid = false;
    var resetInvalid = function resetInvalid(fieldName) {
      var resetValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (isInvalid && !hasChanged(fieldName)) {
        values = _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, fieldName, resetValue));
      }
    };
    if (hasChanged('street')) isInvalid = true;
    resetInvalid('streetId');
    resetInvalid('streetFiasId');
    if (hasChanged('house')) isInvalid = true;
    resetInvalid('house', '');
    resetInvalid('houseId');
    resetInvalid('houseFiasId');
    resetInvalid('flat', '');
    if (hasChanged('flat') && isMobile) isInvalid = true;
    resetInvalid('flat', '');
    resetInvalid('connected');
    resetInvalid('highSpeed');
    resetInvalid('geocodeResults');
    if (fromOnchange && hasChanged('flat')) {
      var _values3;
      /** Имитация onBlur для поля формы flat, чтобы кнопка submit стала активной */
      dispatch(setFlatForForm((_values3 = values) === null || _values3 === void 0 ? void 0 : _values3.flat));
      /** сброс цветных тарифов при сбросе адреса */
      dispatch(resetColoredTariffsData());
    }
    if (fromOnchange && !!((_values4 = values) !== null && _values4 !== void 0 && _values4.street) && !prevValues.flat) return;
    dispatch(setCheckAddressData(values));
  };
};
export var setCheckAddressStreet = function setCheckAddressStreet(_ref) {
  var fiasId = _ref.fiasId,
    id = _ref.id,
    label = _ref.label;
  return setCheckAddressFormValues({
    street: label,
    streetFiasId: fiasId,
    streetId: id
  });
};
export var setCheckAddressHouse = function setCheckAddressHouse(_ref2) {
  var fiasId = _ref2.fiasId,
    id = _ref2.id,
    label = _ref2.label;
  return setCheckAddressFormValues({
    house: label,
    houseFiasId: fiasId,
    houseId: id
  });
};
export var setCheckAddressFlat = function setCheckAddressFlat(flat) {
  return setCheckAddressFormValues({
    flat: flat
  });
};
export var getTariffsByColor = function getTariffsByColor(_ref3) {
  var houseColor = _ref3.houseColor,
    isHighSpeedAvailable = _ref3.isHighSpeedAvailable;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _yield$fetchTariffsBy, isSuccess, data, _data$tabsSettings, validTab;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchTariffsByColor({
              houseColor: houseColor,
              isHighSpeedAvailable: isHighSpeedAvailable
            });
          case 2:
            _yield$fetchTariffsBy = _context.sent;
            isSuccess = _yield$fetchTariffsBy.isSuccess;
            data = _yield$fetchTariffsBy.data;
            if (isSuccess && data !== null && data !== void 0 && data.tabsSettings && data !== null && data !== void 0 && data.tariffs) {
              validTab = validateSelectedTab((_data$tabsSettings = data.tabsSettings) === null || _data$tabsSettings === void 0 ? void 0 : _data$tabsSettings.selectedTab, data.tariffs);
              if (validTab) {
                dispatch(setTariffsGroup(validTab));
                dispatch(setColoredTariffsData(_objectSpread({}, data)));
              }
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var runCheckAddress = function runCheckAddress() {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var geocodeResults, state, addressDataForOldMethod, _getCheckAddressReque, city, flat, house, houseFiasId, street, connected, highSpeed, houseColor, connectionData, _mapCheckConnectionRe;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch(setIsLoading(true));
            _context2.prev = 1;
            state = getState();
            addressDataForOldMethod = getFullAddressData(state);
            _getCheckAddressReque = getCheckAddressRequestData(state), city = _getCheckAddressReque.city, flat = _getCheckAddressReque.flat, house = _getCheckAddressReque.house, houseFiasId = _getCheckAddressReque.houseFiasId, street = _getCheckAddressReque.street;
            highSpeed = false;
            houseColor = -1;
            _context2.prev = 7;
            _context2.next = 10;
            return checkHouseConnection({
              houseFiasId: houseFiasId || undefined,
              flat: flat,
              data: addressDataForOldMethod
            });
          case 10:
            connectionData = _context2.sent;
            _mapCheckConnectionRe = mapCheckConnectionResponse(connectionData);
            connected = _mapCheckConnectionRe.connected;
            highSpeed = _mapCheckConnectionRe.highSpeed;
            houseColor = _mapCheckConnectionRe.houseColor;
            _context2.next = 21;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](7);
            captureException(_context2.t0);
            connected = false;
          case 21:
            _context2.next = 23;
            return executeYMapsApi(function (api) {
              return api.geocode("".concat(city, ", ").concat(street, ", ").concat(house, ", ").concat(flat));
            }).then(pointFromGeocodeResponse);
          case 23:
            geocodeResults = _context2.sent;
            if (connected) {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              dispatch(getTariffsByColor({
                houseColor: houseColor,
                isHighSpeedAvailable: highSpeed
              }));
            }
            sendVkCheckAddressEventAnalytics(connected);
            dispatch(setCheckAddressDetails({
              connected: connected,
              geocodeResults: geocodeResults,
              highSpeed: highSpeed
            }));
            _context2.next = 34;
            break;
          case 29:
            _context2.prev = 29;
            _context2.t1 = _context2["catch"](1);
            captureException(_context2.t1);
            dispatch(setCheckAddressDetails({
              connected: false,
              geocodeResults: geocodeResults,
              highSpeed: false
            }));
            vkPushEvent(VkGoalEvent.shpdInitiateNotAddress);
          case 34:
            _context2.prev = 34;
            dispatch(setIsLoading(false));
            return _context2.finish(34);
          case 37:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 29, 34, 37], [7, 17]]);
    }));
    return function (_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var runMobileCheckAddress = function runMobileCheckAddress() {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var state, pageType, isConvergent, addressData, addressDataForOldMethod, _yield$checkHouseConn, connected, highSpeed, houseColor, checkingResult;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = getState();
            pageType = getAnalyticEventType(state);
            isConvergent = isPageTypeFmc(state);
            addressData = getCheckAddressRequestData(state);
            addressDataForOldMethod = getFullAddressData(state);
            dispatch(setIsLoading(true));
            _context3.prev = 6;
            _context3.next = 9;
            return checkHouseConnection({
              houseFiasId: addressData.houseFiasId || undefined,
              flat: addressData.flat,
              data: addressDataForOldMethod
            }).then(mapCheckConnectionResponse);
          case 9:
            _yield$checkHouseConn = _context3.sent;
            connected = _yield$checkHouseConn.connected;
            highSpeed = _yield$checkHouseConn.highSpeed;
            houseColor = _yield$checkHouseConn.houseColor;
            if (connected) {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              dispatch(getTariffsByColor({
                houseColor: houseColor,
                isHighSpeedAvailable: highSpeed
              }));
            }
            dispatch(setCheckAddressDetails({
              connected: connected,
              highSpeed: highSpeed
            }));
            sendVkCheckAddressEventAnalytics(connected);
            _context3.next = 23;
            break;
          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](6);
            captureException(_context3.t0);
            dispatch(setCheckAddressDetails({
              connected: false,
              highSpeed: false
            }));
            vkPushEvent(VkGoalEvent.shpdInitiateNotAddress);
          case 23:
            _context3.prev = 23;
            dispatch(setIsLoading(false));
            return _context3.finish(23);
          case 26:
            checkingResult = getTextStatusForMobileCheckAddress(state);
            sendCheckAddressResultTextAnalytics({
              addressData: addressData,
              checkingResult: checkingResult,
              isConvergent: isConvergent,
              pageType: pageType
            });
          case 28:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[6, 18, 23, 26]]);
    }));
    return function (_x4, _x5) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var runCheckAddressResult = function runCheckAddressResult(checkingResult, addressData) {
  return function (_, getState) {
    var state = getState();
    var pageType = getAnalyticEventType(state);
    var isConvergent = isPageTypeFmc(state);
    sendCheckAddressResultTextAnalytics({
      addressData: addressData,
      checkingResult: checkingResult,
      isConvergent: isConvergent,
      pageType: pageType
    });
  };
};
export var runLeavePhoneClick = function runLeavePhoneClick() {
  return function (_, getState) {
    var state = getState();
    var pageType = getAnalyticEventType(state);
    var isConvergent = isPageTypeFmc(state);
    sendLeavePhoneClickAnalytics({
      isConvergent: isConvergent,
      pageType: pageType
    });
  };
};
export var setChangePositionTop = function setChangePositionTop(values) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch(setPositionNavButtons(values));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x6) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var setMarkerAddress = function setMarkerAddress(values) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var state, geocode, _yield$executeYMapsAp, geocodeResults, houseNumber, streetName, cityId, _yield$getStreetsForC, isConnected, streetId;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            state = getState();
            geocode = getCheckAddressYandexGeocoderData(state);
            _context5.prev = 2;
            _context5.next = 5;
            return executeYMapsApi(function (api) {
              return api.geocode(values.get('coords'), {
                kind: 'house',
                results: GEOCODE_FIRST_RESULT
              });
            }).then(markerFromGeocodeResponse);
          case 5:
            _yield$executeYMapsAp = _context5.sent;
            geocodeResults = _yield$executeYMapsAp.geocodeResults;
            houseNumber = _yield$executeYMapsAp.houseNumber;
            streetName = _yield$executeYMapsAp.streetName;
            if (!isOldCoordinates((geocode === null || geocode === void 0 ? void 0 : geocode.coordinates) || [], geocodeResults === null || geocodeResults === void 0 ? void 0 : geocodeResults.coordinates)) {
              _context5.next = 11;
              break;
            }
            return _context5.abrupt("return");
          case 11:
            dispatch(setRenderTooltip(false));
            cityId = getCheckAddressCityId(getState()); // Запрос Id улицы
            _context5.next = 15;
            return getStreetsForCity(cityId, streetName).then(mapStreetSuggestionsResponse).then(function (street) {
              var _street$, _street$2;
              // @ts-expect-error fix later
              if (street.length) dispatch(setCheckAddressStreet(street[0]));
              return {
                isConnected: (_street$ = street[0]) === null || _street$ === void 0 ? void 0 : _street$.isConnected,
                streetId: (_street$2 = street[0]) === null || _street$2 === void 0 ? void 0 : _street$2.id
              };
            });
          case 15:
            _yield$getStreetsForC = _context5.sent;
            isConnected = _yield$getStreetsForC.isConnected;
            streetId = _yield$getStreetsForC.streetId;
            if (!isConnected) {
              _context5.next = 21;
              break;
            }
            _context5.next = 21;
            return getHousesForStreet(streetId, houseNumber).then(mapHouseSuggestionsResponse).then(function (house) {
              if (house[0]) {
                // @ts-expect-error fix later
                dispatch(setCheckAddressHouse(house[0]));
                return dispatch(setMarkerAddressData({
                  geocodeResults: geocodeResults
                }));
              }

              /**
                Когда по данному streetId не находим нужного нам дома в ДБ => показываем пользователю,
                что по данному адресу нет подключения.
                Для этого добавляем в стор номер дома и в id = NOT_FOUND_HOUSE,
                чтобы не путать запрос с разными ошибками в методе runCheckAddress
              */
              // @ts-expect-error fix later
              dispatch(setCheckAddressHouse({
                id: NOT_FOUND_HOUSE,
                label: houseNumber
              }));
              return dispatch(setMarkerAddressData({
                geocodeResults: geocodeResults
              }));
            });
          case 21:
            _context5.next = 27;
            break;
          case 23:
            _context5.prev = 23;
            _context5.t0 = _context5["catch"](2);
            captureException(_context5.t0);
            dispatch(resetStore());
          case 27:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 23]]);
    }));
    return function (_x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};